/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Credit_ApprovedInputs */

const en_so_credit_approved = /** @type {(inputs: So_Credit_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit approved`)
};

/**
* | output |
* | --- |
* | "Credit approved" |
*
* @param {So_Credit_ApprovedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_credit_approved = /** @type {((inputs?: So_Credit_ApprovedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Credit_ApprovedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_credit_approved(inputs)
});